import Vitya from './assets/withCaption/vitya.png';
import Stas from './assets/withCaption/stas.png';
import Ksenia from './assets/withCaption/ksenia.png';
import Maxim from './assets/withCaption/max.png';
import Misha from './assets/withCaption/misha.png';
import Ulia from './assets/withCaption/ulia.png';
import Natasha from './assets/withCaption/natasha.png';
import Ivan from './assets/withCaption/ivan.png';
import Dasha from './assets/withCaption/dasha.png';
import MishaC from './assets/withCaption/mishaC.png';
import MishaB from './assets/withCaption/mishaB.png';
import Jenay from './assets/withCaption/jenay.png';

const TalentsList = [
    { // 1
        firstName: 'Виктор',
        lastName: 'Ряснов',
        profession: 'Генеральный\nдиректор',
        avatar: Vitya,
    },
    { // 3
        firstName: 'Евгений',
        lastName: 'Недошковский',
        profession: 'Партнер',
        avatar: Jenay,
    },
    { // 5
        firstName: 'Наталья',
        lastName: 'Богомолова',
        profession: 'Бэкофис,\nлидер направления',
        avatar: Natasha,
    },
    { // 7
        firstName: 'Дарья',
        lastName: 'Портнова',
        profession: 'Дизайн,\nлидер направления',
        avatar: Dasha,
    },
    { // 9
        firstName: 'Максим',
        lastName: 'Шпаковский',
        profession: 'Дизайн-спринты,\nлидер направления',
        avatar: Maxim,
    },
    { // 11
        firstName: 'Ксения',
        lastName: 'Петрушина',
        profession: 'Директор\nпо исследовательским проектам',
        avatar: Ksenia,
    },
    { // 2
        firstName: 'Михаил',
        lastName: 'Беляев',
        profession: 'Партнер',
        avatar: MishaB,
    },
    { // 4
        firstName: 'Станислав',
        lastName: 'Моисеев',
        profession: 'Партнер, лидер\nисследовательского направления',
        avatar: Stas,
    },
    { // 6
        firstName: 'Михаил',
        lastName: 'Бакланов',
        profession: 'IT-разработка,\nлидер направления',
        avatar: Misha,
    },
    { // 8
        firstName: 'Юлия',
        lastName: 'Буракова',
        profession: 'Спецпроекты,\nлидер направления',
        avatar: Ulia,
    },
    { // 10
        firstName: 'Иван',
        lastName: 'Ждакаев',
        profession: 'Сервисные коммуникации,\nлидер направления',
        avatar: Ivan,
    },
    { // 13
        firstName: 'Михаил',
        lastName: 'Царев',
        profession: 'Старший менеджер\nIT-продуктов',
        avatar: MishaC,
    },
];

export default TalentsList;
